import React, { FC, memo, ReactElement } from 'react'
import Script from 'next/script'
import Config from '@/utils/Config'
import min from '@/utils/text/min'
import { AdDataProps } from '@/components/Ads/types/AdsTypes'
import { useConsentManager } from '@/utils/consent/ConsentInfoProvider'

const AdsScript: FC<AdDataProps> = ({ layoutData }): ReactElement | null => {
    const { consentInfo } = useConsentManager()
    if (
        false === Config.ADS_ACTIVE ||
        false === layoutData?.meta?.ad?.adsEnabledForLayout ||
        consentInfo?.consent_info !== 'on'
    ) {
        return null
    }

    return (
        <Script
            id="ads-metatag-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: min(`
                        if (!window.S1_PIANO) {
                            window.S1_LOADED = window.S1_LOADED || {};
                            window.S1_LOADED.ads = 'loading';
                            const script = document.createElement('script');
                            script.async = true;
                            script.src = new URLSearchParams(location.search).get('sdgmt') === 'preview'
                                ? '${Config.METATAG}'.replace('/live/', '/preview/')
                                : '${Config.METATAG}';
                            script.onload = () => { window.S1_LOADED.ads = 'loaded' };
                            script.onerror = () => { window.S1_LOADED.ads = 'error' };
                            document.head.append(script);
                        }
                    `),
            }}
        />
    )
}

export default memo(AdsScript)
